import script from "./AllocatedWorkFrom.vue?vue&type=script&setup=true&lang=ts"
export * from "./AllocatedWorkFrom.vue?vue&type=script&setup=true&lang=ts"

import "./AllocatedWorkFrom.vue?vue&type=style&index=0&id=3405e036&lang=css"

const __exports__ = script;

export default __exports__